import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useInitializeHeaderValidations } from "../hooks/useInitializeHeaderValidations";
import { selectProcedure } from "@EUForms/selectors";
import { fieldPatterns } from "../util/fieldPatterns";
import { useCurrentShipmentType } from "@hooks/useCurrentShipmentType";

 const ErrorInitializer=({children})=>{
    const {isImportShipment}=useCurrentShipmentType()
    const dispatch=useDispatch()
    const procedure=useSelector(selectProcedure)
    const validationPattern=React.useMemo(()=>fieldPatterns(isImportShipment,procedure),[isImportShipment,procedure])
    const {initHeaderTabValidation,repeatableValidationMethods}=useInitializeHeaderValidations("headerTab",validationPattern)
    const isProcI2AorB=["I2A","I2B"].includes(procedure)

    useEffect(()=>{
      dispatch(initHeaderTabValidation())
    },[validationPattern])

 
   return children && children({procedure,isProcI2AorB,repeatableValidationMethods})
   
}

export default React.memo(ErrorInitializer)